export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZES = [DEFAULT_PAGE_SIZE, 20, 50, 100]
